export default __webpack_public_path__ + "static/media/sec2img.a558df82.png";